import axios, { AxiosResponse } from 'axios';
import { User } from 'src/store/user/types';
import { setToken, setUser } from 'src/utils/authHelper';
import { setAxiosToken } from 'src/utils/axiosHelper';
import { action } from 'typesafe-actions';
import { history } from './../../index';
import { logout as logoutHelper } from './../../utils/authHelper';
import { alertError } from './../alert/actions';
import { AuthActionTypes } from './types';

export const loginUser = (username: string, password: string) => {
  const fetchRequest = () => action(AuthActionTypes.LOGIN_REQUEST);
  const fetchSuccess = (user: User) => action(AuthActionTypes.LOGIN_SUCCESS, user);
  const fetchError = (error: Error) => action(AuthActionTypes.LOGIN_FAILURE, error);

  interface Response {
    user: User;
    token: string;
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());
    axios
      .post('/auth/login', {
        username,
        password
      })
      .then((res: AxiosResponse<Response>) => {
        setAxiosToken(res.data.token);
        setToken(res.data.token);
        setUser(res.data.user);
        history.push('/');
        dispatch(fetchSuccess(res.data.user));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const logout = () => {
  return (dispatch: any) => {
    dispatch(action(AuthActionTypes.LOGOUT));
    logoutHelper();
    history.push('/login');
  };
};



// WEBPACK FOOTER //
// ./src/store/auth/actions.ts